import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FolderSharedSvg = function FolderSharedSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.603 2.5H2v18.988h2.5v-1.475H3.481V3.975H7.99l3.704 3.687h8.826v2.728H22V6.187h-9.693z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.653 10.39a3.26 3.26 0 0 1 2.286-.934c.857 0 1.68.336 2.286.934s.946 1.409.946 2.254c0 .846-.34 1.656-.946 2.254a3.26 3.26 0 0 1-2.286.934c-.857 0-1.68-.336-2.286-.934a3.17 3.17 0 0 1-.946-2.254c0-.845.34-1.656.946-2.254m2.286.483c-.476 0-.933.187-1.27.519a1.76 1.76 0 0 0-.526 1.252c0 .47.19.92.526 1.252a1.808 1.808 0 0 0 2.54 0c.337-.332.526-.782.526-1.252s-.19-.92-.526-1.252a1.8 1.8 0 0 0-1.27-.52",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.249 9.456c.857 0 1.68.336 2.285.934.607.598.947 1.409.947 2.254 0 .846-.34 1.656-.947 2.254a3.26 3.26 0 0 1-2.285.934v-1.417c.476 0 .933-.186 1.27-.518a1.76 1.76 0 0 0 .526-1.253c0-.47-.19-.92-.526-1.252a1.8 1.8 0 0 0-1.27-.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.939 16.54c1.891-.002 3.75.489 5.388 1.423l.358.204V21.5H6.193v-3.333l.358-.204a10.85 10.85 0 0 1 5.387-1.422m4.31 2.455a9.4 9.4 0 0 0-4.309-1.037h-.001a9.4 9.4 0 0 0-4.31 1.037v1.088h8.62z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.942 16.876c.944.24 1.85.605 2.695 1.087l.358.205V21.5h-3.232v-1.417h1.796v-1.088a9.4 9.4 0 0 0-1.975-.747z"
  }));
};
export var FolderShared = function FolderShared(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FolderSharedSvg
  }));
};